import type { Editor } from "@tiptap/vue-3";
import type { ComputedRef, Ref } from "vue";
import { createContext } from "reka-ui";

/* eslint-disable no-unused-vars */
// Define the TiptapContext type
export interface TiptapEditorNode {
  id: string;
  name: string;
  type: string;
  icon: string;
  content: string;
  position: number;
  nodeSize: number;
  selected: boolean;
}

export interface TiptapContext {
  editor: ComputedRef<Editor | null>;
  editorNodes: Ref<TiptapEditorNode[]>;
  sidebarVisible: Ref<boolean>;
  selectedNodeId: Ref<string>;
  toggleSidebar: () => void;
  selectNode: (id: string) => void;
  deleteNode: (id: string) => boolean | void;
  duplicateNode: (id: string) => boolean | void;
  reorderNodes: (params: { sourceId: string; targetId: string; position: "before" | "after" }) => boolean | void;
  updateEditorNodes: () => void;
  // Add these missing properties that are used in TiptapProvider.vue
  canUndo: ComputedRef<boolean>;
  canRedo: ComputedRef<boolean>;
  metadata: ComputedRef<{
    lastSaved: Date | null;
    wordCount: number;
    charCount: number;
    readingTime: string;
  }>;
  updateMetadata: () => void;
}
/* eslint-enable no-unused-vars */

// Create context for Tiptap components
export const [useTiptapContext, provideTiptapContext] = createContext<TiptapContext>("TiptapEditor");

export { default as TiptapContent } from "./TiptapContent.vue";
export { default as TiptapIcon } from "./TiptapIcon.vue";
export { default as TiptapProvider } from "./TiptapProvider.vue";
export { default as TiptapToolbar } from "./TiptapToolbar.vue";
